import { useState } from "react";

export default function Support() {
  const [active, setActive] = useState("funding");

  return (
    <div className="min-h-screen w-full flex justify-center items-start bg-gradient-to-b from-black to-green-900 p-6">
      <div className="w-full max-w-4xl bg-white/8 backdrop-blur-lg border border-white/10 rounded-2xl p-6 shadow-xl">

        <h1 className="text-white text-3xl font-bold text-center mb-6">Project Support & Teams</h1>

        {/* Buttons to switch sections */}
        <div className="flex justify-center gap-3 mb-6">
          <button
            onClick={() => setActive("funding")}
            className={`px-4 py-2 rounded-full font-medium focus:outline-none transition-all ${
              active === "funding"
                ? "bg-green-600 text-white shadow-lg"
                : "bg-white/10 text-white/80 hover:bg-white/20"
            }`}
            aria-pressed={active === "funding"}
          >
            Funding Agency
          </button>

          <button
            onClick={() => setActive("implement")}
            className={`px-4 py-2 rounded-full font-medium focus:outline-none transition-all ${
              active === "implement"
                ? "bg-green-600 text-white shadow-lg"
                : "bg-white/10 text-white/80 hover:bg-white/20"
            }`}
            aria-pressed={active === "implement"}
          >
            Implementing Agency
          </button>

          <button
            onClick={() => setActive("technical")}
            className={`px-4 py-2 rounded-full font-medium focus:outline-none transition-all ${
              active === "technical"
                ? "bg-green-600 text-white shadow-lg"
                : "bg-white/10 text-white/80 hover:bg-white/20"
            }`}
            aria-pressed={active === "technical"}
          >
            Technical Team
          </button>
        </div>

        {/* SECTION: FUNDING AGENCY */}
        {active === "funding" && (
          <section className="bg-white/6 p-5 rounded-xl border border-white/6 mb-6">
            <h2 className="text-white text-2xl font-semibold mb-4">Funding Agency</h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* HEFA */}
              <div className="bg-white/10 p-4 rounded-lg text-center">
                <img src="/HEFA.jpeg" alt="HEFA" className="h-20 mx-auto object-contain rounded-md" />
                <h3 className="text-white font-bold mt-3">HEFA (Higher Education Financing Agency)</h3>
                <p className="text-green-200 text-sm mt-2">Higher Education Financing Agency (HEFA) is a joint venture company of Canara Bank and Ministry of Education GoI. HEFA provides financial assistance for creation of educational infrastructure and R&D in India’s premier educational Institutions</p>
                
                <a href="https://hefa.co.in/" target="_blank" rel="noreferrer" className="text-blue-300 underline text-sm block mt-2">HEFA Official Website</a>
              </div>

              {/* Canara Bank */}
              <div className="bg-white/10 p-4 rounded-lg text-center">
                <img src="/Canara_Bank.jpg" alt="Canara Bank" className="h-20 mx-auto object-contain rounded-md" />
                <h3 className="text-white font-bold mt-3">Canara Bank</h3>
                <p className="text-green-200 text-sm mt-2">Widely known for customer centricity, Canara Bank was founded by Shri Ammembal Subba Rao Pai, a great visionary and philanthropist, in July 1906, at Mangalore, then a small port town in Karnataka. The Bank has gone through the various phases of its growth trajectory over hundred years of its existence. Growth of Canara Bank was phenomenal, especially after nationalization in the year 1969, attaining the status of a national level player in terms of geographical reach and clientele segments. Eighties was characterized by business diversification for the Bank. In June 2006, the Bank completed a century of operation in the Indian banking industry.</p>
                
                <a href="https://en.wikipedia.org/wiki/Canara_Bank" target="_blank" rel="noreferrer" className="text-blue-300 underline text-sm block mt-2">Canara Bank Website</a>
              </div>

              {/* Ministry of Education */}
              <div className="bg-white/10 p-4 rounded-lg text-center">
                <img src="/ministry of edu.jpg" alt="Ministry of Education" className="h-20 mx-auto object-contain rounded-md" />
                <h3 className="text-white font-bold mt-3">Ministry of Education</h3>
                <p className="text-green-200 text-sm mt-2">Education plays a significant and remedial role in balancing the socio-economic fabric of the Country. Since citizens of India are its most valuable resource, our billion-strong nation needs the nurture and care in the form of basic education to achieve a better quality of life. This warrants an all-round development of our citizens, which can be achieved by building strong foundations in education. In pursuance of this mission, the Ministry of Education (MoE) was created on September 26, 1985, through the 174th amendment to the Government of India (Allocation of Business) Rules, 1961.</p>
                
                <a href="https://www.education.gov.in" target="_blank" rel="noreferrer" className="text-blue-300 underline text-sm block mt-2">Ministry Website</a>
              </div>
            </div>
          </section>
        )}

        {/* SECTION: IMPLEMENTING AGENCY */}
        {active === "implement" && (
          <section className="bg-white/6 p-5 rounded-xl border border-white/6 mb-6">
            <h2 className="text-white text-2xl font-semibold mb-4">Implementing Agency</h2>

            <div className="flex flex-col md:flex-row items-center gap-6">
              <img src="/NITJSR.jpg" alt="NIT Jamshedpur" className="h-32 w-32 object-contain rounded-md shadow-md" />

              <div className="flex-1 text-white">
                <h3 className="text-white font-bold text-xl">National Institute of Technology Jamshedpur</h3>
                <p className="text-green-200 mt-2 text-sm">NIT Jamshedpur is the implementing institute responsible for project execution, research, and development activities, hardware procurement, field trials and coordination with funding agency.</p>
                <p className="text-white-200 text-sm mt-2">National Institute of Technology Jamshedpur,earlier known as Regional Institute of Technology was established on 15th August 1960 as a joint venture of Government of India and the Government of Bihar in the chain of REC's (Regional Engineering College) in India with the aim to generate technical graduates of highest standards who could provide technological leadership to the region</p>
                <p className="text-white/80 mt-2 text-sm">Organizer: NIT Jamshedpur — Project Coordinator Office</p>
                <a href="https://www.nitjsr.ac.in/" target="_blank" rel="noreferrer" className="text-blue-300 underline text-sm block mt-3">NIT Jamshedpur Official Website</a>
              </div>
            </div>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="bg-white/8 p-3 rounded-lg">
                <h4 className="text-white font-semibold">Project Coordinator</h4>
                <p className="text-green-200 text-sm mt-1">Dr. Surajit Kundu — Project Incharge (NIT Jamshedpur)</p>
              </div>

              <div className="bg-white/8 p-3 rounded-lg">
                <h4 className="text-white font-semibold">Implementing Office</h4>
                <p className="text-green-200 text-sm mt-1">NIT Jamshedpur — Office of Sponsored Projects & Research</p>
              </div>
            </div>
          </section>
        )}

        {/* SECTION: TECHNICAL TEAM */}
        {active === "technical" && (
          <section className="bg-white/6 p-5 rounded-xl border border-white/6 mb-6">
            <h2 className="text-white text-2xl font-semibold mb-4">Technical Team</h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* Surajit */}
              <div className="bg-gradient-to-br from-emerald-800 to-black p-6 rounded-2xl text-center shadow-2xl">
                <img src="/Surajit.jpg" alt="Surajit" className="h-36 w-36 rounded-full mx-auto object-cover border-4 border-green-400 shadow-lg" />
                <h2 className="text-white font-bold text-2xl mt-4 tracking-wide">Dr. Surajit Kundu</h2>
                <p className="text-green-200 text-sm mt-2">Project Incharge (PI)</p>
                <p className="text-white/80 text-sm mt-3 italic">Provides strategic leadership for the project, overseeing research planning, technical development, and field implementation while ensuring compliance, quality, and timely achievement of project milestones.</p>
              </div>

              {/* Samrat */}
              <div className="bg-gradient-to-br from-emerald-800 to-black p-6 rounded-2xl text-center shadow-2xl">
                <img src="/Samrat.jpg" alt="Samrat" className="h-36 w-36 rounded-full mx-auto object-cover border-4 border-green-400 shadow-lg" />
                <h2 className="text-white font-bold text-2xl mt-4 tracking-wide">Samrat Das</h2>
                <p className="text-green-200 text-sm mt-2">Project Associate</p>
                <p className="text-white/80 text-sm mt-3 italic">Handles data visualization, hardware configuration, frontend & backend web development for system enhancement.</p>
              </div>

              {/* Rajkumar */}
              <div className="bg-gradient-to-br from-emerald-800 to-black p-6 rounded-2xl text-center shadow-2xl">
                <img src="/Rajkumar.jpg" alt="Rajkumar" className="h-36 w-36 rounded-full mx-auto object-cover border-4 border-green-400 shadow-lg" />
                <h2 className="text-white font-bold text-2xl mt-4 tracking-wide">Rajkumar Mandal</h2>
                <p className="text-green-200 text-sm mt-2">Project Assistant</p>
                <p className="text-white/80 text-sm mt-3 italic"> Manages GNSS hardware integration, coordinates field data collection, and ensures accurate geo-referenced sensor readings.</p>
              </div>

              {/* Somesh */}
              <div className="bg-gradient-to-br from-emerald-800 to-black p-6 rounded-2xl text-center shadow-2xl">
                <img src="/Somesh.jpg" alt="Somesh" className="h-36 w-36 rounded-full mx-auto object-cover border-4 border-green-400 shadow-lg" />
                <h2 className="text-white font-bold text-2xl mt-4 tracking-wide">Somesh Ghosh</h2>
                <p className="text-green-200 text-sm mt-2">Technical Supporter</p>
                <p className="text-white/80 text-sm mt-3 italic">Supports for backend development, and database management.</p>
              </div>

              {/* Harshit */}
              <div className="bg-gradient-to-br from-emerald-800 to-black p-6 rounded-2xl text-center shadow-2xl">
                <img src="/Harshit.jpg" alt="Harshit" className="h-36 w-36 rounded-full mx-auto object-cover border-4 border-green-400 shadow-lg" />
                <h2 className="text-white font-bold text-2xl mt-4 tracking-wide">Harshit Raj</h2>
                <p className="text-green-200 text-sm mt-2">Technical Supporter</p>
                <p className="text-white/80 text-sm mt-3 italic">Supports UI development, frontend improvement.</p>
              </div>
            </div>
          </section>
        )}

      </div>
    </div>
  );
}

